module.exports = __webpack_public_path__ + "static/img/yeswecan0040.c0f7192.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0040.png
// module id = 615
// module chunks = 1